import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../shared/config";

// Actualités lues : mémorisées sur le compte (serveur), avec copie locale pour un affichage immédiat.
const EVT = 'actualites-lues-maj';
export const luesKey = (user) => `actualites_lues_${user?.id}`;
export const lireLues = (user) => { try { return JSON.parse(localStorage.getItem(luesKey(user)) || '[]'); } catch { return []; } };
const ecrire = (user, ids) => { try { localStorage.setItem(luesKey(user), JSON.stringify(ids)); } catch {} window.dispatchEvent(new Event(EVT)); };

const enCours = {};
export const syncLues = (user) => {
  if (!user?.id) return Promise.resolve([]);
  if (!enCours[user.id]) {
    enCours[user.id] = axios.get(`${API}/actualites/lues`).then(r => {
      const local = lireLues(user);
      const serveur = r.data?.ids || [];
      const manquants = local.filter(id => !serveur.includes(id));
      if (manquants.length) axios.post(`${API}/actualites/lues`, { ids: manquants }).catch(() => {});
      const tout = [...new Set([...serveur, ...local])];
      ecrire(user, tout);
      return tout;
    }).catch(() => lireLues(user)).finally(() => { setTimeout(() => { delete enCours[user.id]; }, 30000); });
  }
  return enCours[user.id];
};

export const marquerLue = (user, id) => {
  if (!user?.id || !id) return;
  const lues = lireLues(user);
  if (lues.includes(id)) return;
  ecrire(user, [...lues, id]);
  axios.post(`${API}/actualites/lues`, { ids: [id] }).catch(() => {});
};

export const useLues = (user) => {
  const [lues, setLues] = useState(() => lireLues(user));
  useEffect(() => {
    const maj = () => setLues(lireLues(user));
    maj();
    window.addEventListener(EVT, maj);
    syncLues(user);
    return () => window.removeEventListener(EVT, maj);
  }, [user]);
  return lues;
};
